import { t } from "@lingui/macro"

export const getSuiteFeatureLabels = () => ({
    thirdGuestCapacity: t`legend-third-guest-capacity`,
    connectingSuite: t`legend-connecting-suite`,
    wheelchairAccessible: t`legend-wheelchair-accessible`,
    bathShowerCombination: t`legend-bath-shower-combination`,
    bathShowerSeparate: t`legend-bath-shower-separate`,
})
